import { C_ACTION } from '../constans';

export const addPackagingData = (data = []) => ({
  type: C_ACTION.ADD_PACKAGE,
  data,
});
